import styled from 'styled-components';

const ArticleDetailsPage = styled.div`
  margin: 2rem;
`;

const ArticleTitle = styled.div`
  color: #001758;
  font-family: lato, sans-serif;
  font-size: 2.5rem;
  font-weight: 300;
  line-height: 3.1rem;
`;

const ProfilePicContainer = styled.div`
  display: inline-block;
  margin-right: 1rem;
`;

const AuthorNameRow = styled.div`
  margin-top: 1rem;
`;

const AuthorName = styled.div`
  display: inline-block;
  color: #7f7f7f;
  font-family: lato, sans-serif;
  font-weight: 400;
  font-size: 1.6rem;
`;

const ArticleDate = styled.div`
  color: #7f7f7f;
  font-family: lato, sans-serif;
  font-weight: 400;
  font-size: 1.3rem;
  margin-top: 0.5rem;
`;

const ArticleBody = styled.div`
  border-top: 1px solid #efefef;
  margin-top: 1rem;
  padding-top: 1rem;

  img {
    max-width: 100%;
  }
`;

export { ArticleBody, ArticleDate, ArticleDetailsPage, ArticleTitle, AuthorName, AuthorNameRow, ProfilePicContainer };
